import { useCallback, useMemo } from 'react';
import { useMemorizedCacheTags } from '../../hooks/useMemorizedCacheTag';
import { useRoomUsageQuery } from '../../types/planung-graphql-client-defs';

/**
 * Sagt für die genannten Räume, ob sie in Zuordnungen oder Sollstunden verwendet werden.
 * Ein verwendeter Raum lässt sich nicht löschen; das Backend lehnt es mit DELETE_BLOCKED ab.
 */
export const useRoomUsage = (uuids: string[]) => {
  const context = useMemorizedCacheTags(['ROOMS', 'LESSONS', 'CURRICULA']);

  const [{ data }] = useRoomUsageQuery({
    variables: { uuids },
    pause: uuids.length === 0,
    context,
  });

  const usedUuids = useMemo(
    () =>
      new Set(
        data?.roomUsage
          .filter((usage) => usage.lessonsCount > 0 || usage.curriculaCount > 0)
          .map((usage) => usage.uuid),
      ),
    [data],
  );

  return useCallback((uuid: string) => usedUuids.has(uuid), [usedUuids]);
};
